export default [
  {
    path: "/forwarder",
    name: "forwarder",
    component: () => import("@/modules/forwarder/Forwarder.vue"),
    children: [
      {
        path: "list",
        name: "list-forwarders",
        component: () => import("@/modules/forwarder/pages/ForwarderList.vue"),
        meta: { permissions: ["suppliers-show"] }
      },
      {
        path: "add",
        name: "add-forwarder",
        component: () => import("@/modules/forwarder/pages/ForwarderAdd.vue"),
        meta: { permissions: ["suppliers-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-forwarder",
        component: () => import("@/modules/forwarder/pages/ForwarderEdit.vue"),
        meta: { permissions: ["suppliers-update"] }
      }
    ]
  }
];